import { createClient } from '@supabase/supabase-js';

// TEMPORARY: Hardcode for testing
const supabaseUrl = 'https://xmobvhepztygeyrlnxsx.supabase.co';
// You MUST replace this with your actual anon key from Supabase dashboard!
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhtb2J2aGVwenR5Z2V5cmxueHN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4NzM4MTgsImV4cCI6MjA4MTQ0OTgxOH0.JEmVA_9i2Nf2Ct_FL-WQXvbphtbCSk2zNNIRdDpnVsk';

console.log('Using Supabase URL:', supabaseUrl);
console.log('Using Supabase Key length:', supabaseAnonKey?.length);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase URL or Anon Key');
}

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});